export const getLeaveData = (store) => store.LeaveForm.editData;
